
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';

import { ClinicService } from '../../../service/admin/clinic.service';
import { InventoryService } from '../../../service/admin/inventory.service';
import { ToasterService } from '../../../service/common/toaster.service';

interface Medicine {
  id: number;
  name: string;
  code: string;
  warehouse_stock?: { quantity: number };
}

interface HistoryRecord {
  created_at: string;
  action: 'ADD' | 'SUPPLY';
  location: string;
  old_quantity: number;
  change_quantity: number;
  total_quantity: number;
  clinic_after_quantity?: number;
}

@Component({
  standalone: true,
  selector: 'app-admin-inventory',
  templateUrl: './admin-inventory.component.html',
  styleUrls: ['./admin-inventory.component.scss'],
  imports: [ CommonModule, FormsModule, TableModule, ToastModule, DropdownModule, InputTextModule, PaginatorModule ],
  providers: [],
})
export class AdminInventoryComponent implements OnInit {

  //================ DATA ================
  medicines: Medicine[] = [];
  history: HistoryRecord[] = [];
  clinics: any[] = [];

  totalRecords = 0;
  loading = false;

  //================ FILTER STATE ================
  page = 1;
  rows = 10;

  filters: any = {
    name: '',
    quantity: '',
    status: ''
  };

  sortField = 'name';
  sortOrder = 'asc';

  statusOptions = [
    { label:"In Stock", value:"in_stock" },
    { label:"Low Stock", value:"low_stock" },
    { label:"Out of Stock", value:"out_of_stock" }
  ];

  //================ MODAL STATES ================
  isPurchaseOrderVisible = false;
  isClinicSupplyVisible = false;
  isHistoryPopupVisible = false;

  selectedItem: Medicine | null = null;

  //================ PURCHASE ORDER FORM ================
  purchaseOrder = { date:new Date().toISOString().slice(0,10) };
  purchaseItems = [ { medicine_id:'', qty:0, price:0, total:0 } ];
  finalPurchaseTotal = 0;

  //================ CLINIC SUPPLY FORM ================
  clinicSupply = { date:new Date().toISOString().slice(0,10), clinic_id:'' };
  clinicRows = [ { medicine_id:'', qty:0 } ];

  constructor(
    private inventoryService: InventoryService,
    private clinicService: ClinicService,
    private toaster: ToasterService) {}

  ngOnInit(){ 
    this.getClinic();
    this.loadTable({ first: 0, rows: this.rows });   // Initial fetch now paginated
  }

  // Return available warehouse qty for a medicine id (used by template to set input max)
  getAvailableQty(medicine_id:any): number {
    const id = Number(medicine_id);
    if(!id) return 0;
    const med = this.medicines.find(m => m.id === id);
    return med?.warehouse_stock?.quantity ?? 0;
  }

  //================ PAGINATED LOAD ================
  // loadTable(event?: any){
  //   if(event){
  //     this.page = event.first / event.rows + 1;
  //     this.rows = event.rows;
  //   }

  //   this.loading = true;

  //   this.inventoryService.getMedicines({
  //     page:this.page,
  //     limit:this.rows,
  //     name:this.filters.name,
  //     quantity:this.filters.quantity,
  //     status:this.filters.status
  //   }).subscribe((res:any)=>{
  //     // console.log("API RESPONSE => ", res);
  //     this.medicines = res;
  //     this.totalRecords = res.length;
  //     this.loading = false;
  //     console.log('data =>', this.medicines);
  //     console.log('total =>', this.totalRecords);
  //   });
  // }

  applyFilter(field:string,value:any){
    const isEmpty = value === null || value === undefined || value === '';

    if(isEmpty){
      // clear the filter and reset to first page with default rows
      this.filters[field] = '';
      this.page = 1;
      this.rows = 10;
    } else {
      // apply filter and start from first page
      this.filters[field] = value;
      this.page = 1;
    }

    // reload table using the current page/rows/filters
    this.loadTable();
  }

  // loadTable(event?: any){
  //   console.log("LAZY EVENT =>", event);

  //   if(event){
  //       this.page = event.first / event.rows + 1;
  //       this.rows = event.rows;
  //   } else {
  //     this.page = 1;
  //     this.rows = 10;
  //   }

  //   this.inventoryService.getMedicines({
  //     page: this.page,
  //     limit: this.rows,
  //     name: this.filters.name,
  //     quantity: this.filters.quantity,
  //     status: this.filters.status
  //   }).subscribe((res:any)=>{
  //     console.log("Loaded Page:", this.page, "Rows:", res.data.length);

  //     this.medicines = res.data ?? [];
  //     this.totalRecords = res.total ?? 0;
  //   });
  // }

  loadTable(event?: any){
    if(event){
      this.page = event.first / event.rows + 1;
      this.rows = event.rows;
      this.sortField = event.sortField ?? this.sortField;
      this.sortOrder = event.sortOrder === 1 ? 'asc' : 'desc';
    }

    // Build params but omit empty filter values so backend returns default list
    const params: any = {
      page: this.page,
      limit: this.rows,
      sort_field: this.sortField,
      sort_order: this.sortOrder,
    };

    // attach filters only when they have a non-empty value
    for(const [k,v] of Object.entries(this.filters || {})){
      if(v !== null && v !== undefined && v !== ''){
        params[k] = v as any;
      }
    }

    this.inventoryService.getMedicines(params).subscribe((res:any)=>{
      this.medicines = res.data ?? [];
      this.totalRecords = res.total ?? 0;
    });
  }

  // loadTable(event?:any){
  //   this.page = event.first / event.rows + 1;
  //   this.rows = event.rows;

  //   this.sortField = event.sortField ?? 'name';
  //   this.sortOrder = event.sortOrder === 1 ? 'asc' : 'desc';

  //   this.inventoryService.getMedicines({
  //     page: this.page,
  //     limit: this.rows,
  //     name: this.filters.name,
  //     quantity: this.filters.quantity,
  //     status: this.filters.status,
  //     sort_field: this.sortField,
  //     sort_order: this.sortOrder,
  //   }).subscribe((res:any)=>{
  //     this.medicines = res.data;
  //     this.totalRecords = res.total;
  //   });
  // }



  //================ FILTER TRIGGERS ================
  filterName(val:string){ this.filters.name = val; this.loadTable(); }
  filterQty(val:string){  this.filters.quantity = val; this.loadTable(); }
  filterStatus(val:any){  this.filters.status = val; this.loadTable(); }

  //================ CLINIC LIST =====================
  getClinic(){
    this.clinicService.getClinic().subscribe({
      next:(res:any)=>{ this.clinics = res.data ?? []; },
      error:()=>{ this.clinics=[]; }
    });
  }

  //================ STATUS UI =======================
  getStatus(qty:number|undefined){
    if(!qty) return 'Out of Stock';
    return qty<=20?'Low Stock':'In Stock';
  }
  getStatusClass(qty:number|undefined){
    if(!qty) return 'status-out-of-stock';
    return qty<=20?'status-low':'status-in-stock';
  }

  //================ PURCHASE ORDER ==================
  openPurchaseOrder(){ this.isPurchaseOrderVisible=true; }
  closePurchaseOrder(){
    this.isPurchaseOrderVisible=false;
    this.resetPurchaseForm();
    this.loadTable(); // refresh table
  }

  addPurchaseRow(){ this.purchaseItems.push({medicine_id:'',qty:0,price:0,total:0}); }
  removePurchaseRow(i:number){ this.purchaseItems.splice(i,1); this.calcFinalPurchase(); }

  calcPurchase(i:number){
    let r=this.purchaseItems[i];
    r.total = (r.qty)||0;
    this.calcFinalPurchase();
  }

  calcFinalPurchase(){
    this.finalPurchaseTotal = this.purchaseItems.reduce((t,r)=>t+r.total,0);
  }

  savePurchase(){
    if(!this.purchaseItems.some(row=>row.medicine_id)) {
      this.toaster.warn('Please add at least one product', 'Warning');
      console.log('Purchase Items:', this.purchaseItems);
      return;
    };
    this.purchaseItems.forEach(row=>{
      this.inventoryService.addToWarehouse({medicine_id:row.medicine_id,qty:row.qty})
        .subscribe(()=> this.loadTable());
    });
    this.closePurchaseOrder();
  }

  resetPurchaseForm(){
    this.purchaseItems=[{medicine_id:'',qty:0,price:0,total:0}];
    this.finalPurchaseTotal=0;
  }

  //================ CLINIC SUPPLY ==================
  openClinicSupply(){ this.isClinicSupplyVisible=true; }
  closeClinicSupply(){
    this.isClinicSupplyVisible=false;
    this.resetClinicSupply();
    this.loadTable();
  }

  addSupplyRow(){ this.clinicRows.push({medicine_id:'',qty:0}); }
  removeSupplyRow(i:number){ this.clinicRows.splice(i,1); }

  supplyToClinic(){
    if(!this.clinicSupply.clinic_id) {
      this.toaster.warn('Please select a clinic', 'Warning');
      return;
    };
    if(!this.clinicRows.some(row=>row.medicine_id)) {
      this.toaster.warn('Please add at least one product', 'Warning');
      console.log('Clinic Supply:', this.clinicRows);
      return;
    };
    // Validate requested quantities against warehouse stock
    for(const row of this.clinicRows){
      const med = this.medicines.find(m => m.id === Number(row.medicine_id));
      const available = med?.warehouse_stock?.quantity ?? 0;
      const requested = Number(row.qty) || 0;

      if(requested <= 0){
        this.toaster.warn('Requested quantity must be greater than zero', 'Warning');
        return;
      }

      if(requested > available){
        this.toaster.add({
          severity:'error', summary:'Insufficient stock',
          detail:`Cannot supply ${requested} — only ${available} available in warehouse`
        });
        return;
      }
    }

    // All rows validated — perform API calls
    this.clinicRows.forEach(row=>{
      this.inventoryService.supplyToClinic({clinic_id:this.clinicSupply.clinic_id,medicine_id:row.medicine_id,qty:row.qty})
          .subscribe(()=> this.loadTable());
    });
    this.closeClinicSupply();
  }

  resetClinicSupply(){
    this.clinicSupply={date:new Date().toISOString().slice(0,10),clinic_id:''};
    this.clinicRows=[{medicine_id:'',qty:0}];
  }

  //================ HISTORY POPUP ==================
  openPoHistoryPopup(item:Medicine){
    this.selectedItem=item;
    this.isHistoryPopupVisible=true;

    this.inventoryService.getHistory(item.id).subscribe((res:any)=>{
      this.history=res;
    });
  }

  closeHistoryPopup(){
    this.isHistoryPopupVisible=false;
    this.selectedItem=null;
    this.history=[];
  }
}